module.exports = __webpack_public_path__ + "static/media/icon-exit-door.d1ebde5f.svg";